import React from 'react';
import { CardViewContentBlockProps } from './types';
import { Typography } from '@mui/material';
import CategoryCard from '../../../../common/category-card/CategoryCard';
import CategoryCardGrid from '../../../../common/category-card/CategoryCardGrid';
import { CATEGORY_CARD_ACCENTS } from '../../../../common/category-card/types';
import RegistrationIcon from '../../../../../assets/svg/category-registration.svg?react';
import PolicyIcon from '../../../../../assets/svg/policy.svg?react';
import OwnershipIcon from '../../../../../assets/svg/manual-doc.svg?react';
import SubscriptionIcon from '../../../../../assets/svg/box.svg?react';
import OperationsIcon from '../../../../../assets/svg/business-to-consumer-plan.svg?react';
import AccountingIcon from '../../../../../assets/svg/view-list.svg?react';
import { useTranslation } from 'react-i18next';
import { TAGS_LABELS } from '../../../../common/constants/tags-labels';
import { Helpers } from '../../../../common/helpers/helpers';
import { useAppSelector } from '../../../../common/hooks/useAppSelector';
import { selectAllCompanies } from '../../../../slices/companies/companiesSlice';

export const BusinessCategoryContent = ({ templates, setWorkflow }: CardViewContentBlockProps) => {
  const { t } = useTranslation();
  const company = useAppSelector(selectAllCompanies)[0];
  const templatesFilteredByCategory = [...templates].filter(
    (template) =>
      'dl_workflows' in template && 'is_free' in template && template.category === 'Business'
  );
  const getTemplatesCount = (workflow: string) => {
    return templatesFilteredByCategory.filter((el) => el.dl_workflows?.includes(workflow)).length;
  };
  const getTemplatesCountByWorkflow = (workflow: string) => {
    return templatesFilteredByCategory.filter((el) => el.dl_workflows?.includes(workflow)).length;
  };
  const getFreeTemplatesCount = (workflow: string) => {
    return templatesFilteredByCategory.filter(
      (el) => el.dl_workflows?.includes(workflow) && el.is_free
    ).length;
  };
  const getIcon = (workflow: string) => {
    switch (workflow) {
      case t('tagsLabels.documentWorkflow.company.registration'):
        return <RegistrationIcon />;
      case t('tagsLabels.documentWorkflow.company.agreements'):
        return <PolicyIcon />;
      case t('tagsLabels.documentWorkflow.company.management'):
        return <OwnershipIcon />;
      case t('tagsLabels.documentWorkflow.company.subscriptions'):
        return <SubscriptionIcon />;
      case t('tagsLabels.documentWorkflow.company.generalAdministration'):
        return <OperationsIcon />;
      case t('tagsLabels.documentWorkflow.company.accounting'):
        return <AccountingIcon />;
    }
  };

  const getWorkflowNumber = (workflow: string) => {
    switch (workflow) {
      case t('tagsLabels.documentWorkflow.company.registration'):
        return '1. ';
      case t('tagsLabels.documentWorkflow.company.accounting'):
        return '2. ';
      case t('tagsLabels.documentWorkflow.company.agreements'):
        return '3. ';
      case t('tagsLabels.documentWorkflow.company.generalAdministration'):
        return '4. ';
    }
  };

  return (
    <>
      <Typography
        variant='h3'
        component='h3'
        sx={{ marginBottom: '16px', fontSize: '15px', lineHeight: '24px' }}
      >
        {t('headers.workflows')}
      </Typography>
      <CategoryCardGrid id='libraryBusinessCategoryContentGrid'>
        {TAGS_LABELS.documentWorkflow.business.map((el) =>
          getTemplatesCountByWorkflow(t(el)) > 0 ? (
            <CategoryCard
              id={`libraryBusinessCategoryContentBusinessCard_${el}`}
              title={Helpers.capitalizeTitle(getWorkflowNumber(t(el)) + t(el))}
              countLabel={t(
                getTemplatesCount(t(el)) === 1
                  ? 'categoryCards.templateCountSingular'
                  : 'categoryCards.templateCountPlural',
                { count: getTemplatesCount(t(el)) }
              )}
              accent={CATEGORY_CARD_ACCENTS.Business}
              hasFreeLabel={
                getFreeTemplatesCount(t(el)) > 0 &&
                !company?.stripe_subscription &&
                !company?.stripe_product_id
              }
              onClick={() => setWorkflow(t(el))}
              icon={getIcon(t(el))}
              key={el}
            />
          ) : null
        )}
      </CategoryCardGrid>
    </>
  );
};
